<template>
    <div v-click-outside='outsideClick' :class='{on: open}' class='ui-select'>
        <button type='button' @click='open = !open'><span class='txt'>{{ checkTitle }}</span></button>
        <ul style='max-height:300px; overflow-y: hidden; overflow: auto'>
            <li v-for='(txt, index) in selectData' :key='index' >
                <div class='com-check'>
                    <input :id="'check-'+ index + uidNum" v-model='checkArr' :name="'check-'+uidNum"
                           :value='selectValue[index]'
                           type='checkbox'
                           @change='onChangeCheckBox'
                           @click='onClickCheckBox(selectValue[index], index)'>
                    <label :for="'check-'+ index + uidNum" class='singleline-ellipsis'>{{ txt }}</label>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'SelectCheckForm',
    props: {
        title: {
            type: String,
            default: '',
        },
        selectData: Array,
        selectValue: {
            type: Array,
            default: () => [],
        },
        selectedValue: Array,
        callbackChangeCheck: Function,
    },
    computed: {
        checkTitle() {
            let checkTitle = '';
            let textIndex = this.selectValue.indexOf(this.checkArr[0]);

            if (this.checkArr.length == 1) {
                checkTitle = this.selectData[textIndex];
            } else if (this.checkArr.length >= 2 && this.selectValue.length !== this.checkArr.length) {
                checkTitle = this.selectData[textIndex] + ' 외 ' + (this.checkArr.length - 1) + '개';
            } else if (this.selectValue.length === this.checkArr.length) {
                checkTitle = this.title;
            } else {
                checkTitle = this.title;
            }

            this.$emit('update:set', this.checkArr);

            return checkTitle;
        },
    },
    watch: {
        selectedValue(v) {
            this.checkArr = v;
        },
    },
    data() {
        return {
            uidNum: 0,
            open: false,
            selected: '',
            checkArr: [],
            isFirst: true,
        };
    },
    mounted() {
        this.uidNum = this._uid;
        if (this.selectedValue !== undefined) {
            this.checkArr = this.selectedValue;
        }
    },
    created() {
        this.selected = this.selectData[0];
    },
    methods: {
        outsideClick() {
            this.open = false;
        },
        onClickCheckBox(selectValue, index) { // 0번째 인덱스의 값이 all(전체)일 때 나머지 체크박스를 선택하기 위한 이벤트
            if (selectValue === 'all' && index === 0) {
                const checkBoxArray = document.getElementsByName(`check-${this.uidNum}`);
                const checkBoxLength = checkBoxArray.length;

                for (let i = 1; i < checkBoxLength; i++) {
                    if (checkBoxArray[0].checked === true && checkBoxArray[i].checked === false) {
                        checkBoxArray[i].click();
                    } else if (checkBoxArray[0].checked === false && checkBoxArray[i].checked === true && this.isFirst) {
                        checkBoxArray[i].click();
                    }
                }

                this.isFirst = true;
            }

            if (this.selectValue[0] === 'all' && index !== 0) {
                const checkBoxArray = document.getElementsByName(`check-${this.uidNum}`);

                if (checkBoxArray[index].checked === false) {
                    if (checkBoxArray[0].checked === true) {
                        this.isFirst = false;
                        checkBoxArray[0].click();
                    }
                }
            }

        },
        onChangeCheckBox() {
            if (this.callbackChangeCheck !== undefined) {
                this.callbackChangeCheck(this.checkArr);
            }
        },
    },
};
</script>
<style lang='scss' scoped>
@import "../assets/scss/mixin.scss";

.ui-select {
    display: inline-block;
    position: relative;
    width: 160px;
    height: 32px;

    .com-check {
        display: block;

        label {
            display: block;
        }
    }

    & + .ui-select {
        margin-left: 8px;
    }

    &.on {
        ul {
            display: block;
        }
    }

    button {
        display: block;
        overflow: hidden;
        position: relative;
        width: 100%;
        height: 32px;
        padding-left: 8px;
        border: 1px solid #ced4da;
        border-radius: 4px;
        font-size: 14px;
        line-height: 30px;
        text-align: left;
        color: #7e7777;

        &:focus {
            outline: 0;
        }

        &::after {
            content: "";
            position: absolute;
            right: 8px;
            top: 8px;

            @include ic-tri-arrow;
        }

        .txt {
            display: block;
            overflow: hidden;
            padding-right: 20px;
        }
    }

    ul {
        display: none;
        position: absolute;
        left: 0;
        top: 33px;
        width: 100%;
        padding: 12px 0;
        background: #fff;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        z-index: 1;

        li {
            display: block;
            height: 36px;
            padding: 0 22px;
            font-size: 13px;
            line-height: 36px;
            color: #545454;
            cursor: pointer;

            &.on {
                background-color: rgba(0, 199, 229, 0.1);
            }
        }
    }

    &.full {
        width: 100%;
        height: 44px;

        button {
            height: 44px;
            padding-left: 25px;
            border: 0;
            line-height: 44px;

            &::after {
                top: 16px;
                right: 35px;
            }
        }

        ul {
            top: 46px;
        }
    }
}
</style>
<style scoped>
.singleline-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
